<template>
  <div class="my-3 px-3 py-3">
    <h5 style="color: #000">{{ title }}</h5>
     <!-- <h5 class="count"><strong>Quantidade Total de Ligações: {{ total }} </strong></h5> -->
     <div class="row state-overview" style="width: 100%; padding: 10px;">
        <div class="col-lg-4 col-sm-7">
            <section class="card" id="cardReports" style="margin-bottom: 0 !important;">
                <div class="icons" style="background-color: #27ae60;" >
                    <i class="fas fa-phone"></i>
                </div>
                <div class="titles">
                    <h1 class="count"> <strong>{{ total }}</strong> </h1>
                    <p>Quantidade de Ligações Recebidas</p>
                </div>
            </section>
        </div>
    </div>
    </br>
    <apexchart :options="chartOptions" :series="series" :chart="chart" :height="height" :width="width" :color="color"></apexchart>
  </div>
</template>

<script>
export default {
  props: ['title', 'values', 'max', 'categories', 'total'],
  data: function() {
    return {
      chartOptions: {
        xaxis: {
            categories: this.categories,
            title: {
                text: 'Horários'
            }
        },
        yaxis: {
            title: {
                text: 'Quantidade'
            },
            min: 0,
            max: this.max + 10
        },
        colors: ['#2980b9', '#545454'],
        dataLabels: {
            enabled: true,
        },
        stroke: {
            curve: 'smooth'
        },
        // title: {
        //     text: "Quantidade de Ligações Recebidas:"+this.total,
        //     align: 'left'
        // },
        grid: {
            borderColor: '#e7e7e7',
            row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
            },
        },
        markers: {
            size: 1
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
        }
      },
      series: [{
            name: "Quantidade",
            data: this.values
        }],
      height: 350,
      width: '1100',
      type: 'line',
      colors: ['#77B6EA', '#545454'],
      color: '#000',
      chart: {
            height: 350,
            type: 'line',
            dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2
            },
            toolbar: {
                show: false
            }
        },
    };
  }
};
</script>